import React, { useCallback } from 'react';
import { Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';

import messages from '../../assets/i18n'
import { Creators as actionFilter } from '../../store/ducks/orderFilter'
import havePermissionTo from '../../utils/havePermission';

export default function OrderFilter() {

  const dispatch = useDispatch();

  const lang = useSelector(state => state.language.name);
  const filters = useSelector(state => state.filter);
  const deliveryDateFilter = useSelector(state => state.filter.filterDeliveryDate);
  const permissions = useSelector(state => state.authorization.permissions);

  const getOrders = useCallback((page, filtros) => dispatch({ type: "GET_ORDERS", page: page, filtro: filtros }), [dispatch]);

  const setFilters = (newFilters) => {
    dispatch(actionFilter.filterSet(newFilters, deliveryDateFilter));
  };

  const statusOrders = [
    { id: "", message: messages[lang].all },
    { id: "A", message: messages[lang].statusOrder["A"] },
    { id: "W", message: messages[lang].statusOrder["W"] },
    { id: "S", message: messages[lang].statusOrder["S"] },
    { id: "C", message: messages[lang].statusOrder["C"] },
    { id: "D", message: messages[lang].statusOrder["D"] },
    { id: "I", message: messages[lang].statusOrder["I"] },
    { id: "N", message: messages[lang].statusOrder["N"] },
    { id: "M", message: messages[lang].statusOrder["M"] },
    { id: "PRE_PO", message: messages[lang].preRegistrationStatus },
  ];

  const natureOrders = [
    { id: "", message: messages[lang].all },
    { id: "Normal", message: messages[lang].normal },
    { id: "Amostra", message: messages[lang].amostra },
    { id: "Importado", message: messages[lang].importado },
    { id: "Bonificado MKT", message: messages[lang].bonificadoMkt },
    { id: "Bonificado Compras", message: messages[lang].bonificadoCompras },
  ];

  const sortOrders = [
    { id: "sortByOrderAsc", message: messages[lang].sort["sortByOrderAsc"] },
    { id: "sortByOrderDesc", message: messages[lang].sort["sortByOrderDesc"] },
    { id: "sortByWeekAsc", message: messages[lang].sort["sortByWeekAsc"] },
    { id: "sortByWeekDesc", message: messages[lang].sort["sortByWeekDesc"] },
    { id: "sortByDateIssueAsc", message: messages[lang].sort["sortByDateIssueAsc"] },
    { id: "sortByDateIssueDesc", message: messages[lang].sort["sortByDateIssueDesc"] },
    { id: "sortByDeliveryAsc", message: messages[lang].sort["sortByDeliveryAsc"] },
    { id: "sortByDeliveryDesc", message: messages[lang].sort["sortByDeliveryDesc"] },
  ];

  const companies = [
    { id: '', message: messages[lang].all },
    { id: '001', message: 'Renner' },
    { id: '003', message: 'Camicado' },
    { id: '004', message: 'Youcom' },
  ];

  const handleDoFilter = (e) => {
    if (e.keyCode === 13) {
      getOrders(undefined, filters);
    }
  }

  return (
    <Form className="px-3">
    <Row>
      <Col>
        <Form.Group className="mt-1">
          <Form.Label className="text-2">{messages[lang].Order}</Form.Label>
          <Form.Control
            className="text-2 border-radius-full"
            placeholder={messages[lang].Order}
            type="text"
            value={filters.filters.id}
            onKeyUp={handleDoFilter}
            onChange={event => setFilters(
              {
                ...filters.filters,
                id: event.target.value
              },
            )}
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group className="mt-1">
          <Form.Label className="text-2">{messages[lang].businessWeek}</Form.Label>
          <Form.Control
            className="text-2 border-radius-full"
            placeholder={messages[lang].businessWeek}
            type="number"
            size="2"
            min="0"
            max="53"
            value={filters.filters.calendarioComercial.semanaComercial}
            onKeyUp={handleDoFilter}
            onChange={event => setFilters(
              { 
                ...filters.filters, 
                calendarioComercial: { 
                  ...filters.filters.calendarioComercial, 
                  semanaComercial: isNaN(parseInt(event.target.value)) ? '' : event.target.value
                } 
              },
            )}
          />
        </Form.Group>
      </Col>
      <Col>
      <Form.Group className="mt-1">
        <Form.Label className="text-2">{messages[lang].anoSemanaComercial}</Form.Label>
        <Form.Control
          type="text"
          placeholder={messages[lang].anoSemanaComercial}
          className="text-2 border-radius-full"
          value={filters.filters.anoSemanaComercial}
          onKeyUp={handleDoFilter}
          onChange={event => setFilters({
            ...filters.filters, 
            anoSemanaComercial: event.target.value
          })}
        />
      </Form.Group>
      </Col>
      <Col>
        <Form.Group className="mt-1">
          <Form.Label className="text-2">{messages[lang].status}</Form.Label>
          <Form.Control
            as="select"
            className="text-2 border-radius-full"
            value={filters.filters.status}
            onChange={event => setFilters({
              ...filters.filters, 
              status: event.target.value
            })}>
            {
              statusOrders.map(value => (
                <option key={value.id} value={value.id}>{value.message}</option>
              ))
            }
          </Form.Control>
        </Form.Group>
      </Col>
      <Col>
        <Form.Group className="mt-1">
          <Form.Label className="text-2">{messages[lang].nature}</Form.Label>
          <Form.Control
            as="select"
            className="text-2 border-radius-full"
            value={filters.filters.naturezaPedido}
            onChange={event => setFilters({
              ...filters.filters, 
              naturezaPedido: event.target.value
            })}>
            {
              natureOrders.map(value => (
                <option key={value.id} value={value.id}>{value.message}</option>
              ))
            }
          </Form.Control>
        </Form.Group>
      </Col>
      <Col>
        <Form.Group className="mt-1">
          <Form.Label className="text-2">{messages[lang].cd}</Form.Label>
          <Form.Control
            type="text"
            placeholder={messages[lang].cd}
            className="text-2 border-radius-full"
            value={filters.filters.cd}
            onKeyUp={handleDoFilter}
            onChange={event => setFilters({
              ...filters.filters, 
              cd: event.target.value
            })}
          />
        </Form.Group>
      </Col>
    </Row>
    <Row>
      <Col>
        <Form.Group className="mt-1">
          <Form.Label className="text-2">{messages[lang].carga}</Form.Label>
          <Form.Control
            type="text"
            placeholder={messages[lang].carga}
            className="text-2 border-radius-full"
            value={filters.filters.carga}
            onKeyUp={handleDoFilter}
            onChange={event => setFilters({
              ...filters.filters, 
              carga: event.target.value
            })}
          />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group className="mt-1">
          <Form.Label className="text-2">{messages[lang].dataAgendamentoInicial}</Form.Label>
            <Form.Control
                type="date"
                className="text-2 date-input border-radius-full"
                defaultValue={''}
                onKeyUp={handleDoFilter}
                onChange={event => setFilters(
                    { ...filters.filters, dataAgendamentoInicial: event.target.value },
                )}
            />
        </Form.Group>
      </Col>
      <Col>
        <Form.Group className="mt-1">
          <Form.Label className="text-2">{messages[lang].dataAgendamentoFinal}</Form.Label>
            <Form.Control
                type="date"
                className="text-2 date-input border-radius-full"
                defaultValue={''}
                onKeyUp={handleDoFilter}
                onChange={event => setFilters(
                  { ...filters.filters, dataAgendamentoFinal: event.target.value },
              )}
            />
        </Form.Group>
      </Col>
      {havePermissionTo("filter-provider", permissions) && (
        <Col>
          <Form.Group className="mt-1">
            <Form.Label className="text-2">{messages[lang].provider}</Form.Label>
            <Form.Control
              className="text-2 border-radius-full"
              placeholder={messages[lang].provider}
              type="text"
              value={filters.filters.fornecedor.nome}
              onKeyUp={handleDoFilter}
              onChange={event => setFilters(
                { ...filters.filters, fornecedor: { ...filters.filters.fornecedor, nome: event.target.value } },
              )}
            />
          </Form.Group>
        </Col>
      )}
      { havePermissionTo("filter-company", permissions) && (
        <Col>
          <Form.Group className="mt-1">
            <Form.Label className="text-2">{messages[lang].company}</Form.Label>
            <Form.Control
              as="select"
              className="text-2 border-radius-full"
              value={filters.filters.idEmpresa}
              onChange={event => setFilters({
                ...filters.filters, 
                idEmpresa: event.target.value
              })}>
              {
                companies.map(value => (
                  <option key={value.id} value={value.id}>{value.message}</option>
                ))
              }
            </Form.Control>
          </Form.Group>
        </Col>
      )}
      <Col>
        <Form.Group className="mt-1">
          <Form.Label className="text-2">{messages[lang].sortBy}</Form.Label>
          <Form.Control
            as="select"
            className="text-2 border-radius-full"
            value={filters.filters.ordenacao}
            onChange={event => setFilters({
              ...filters.filters, 
              ordenacao: event.target.value
            })}>
            {
              sortOrders.map(value => (
                <option key={value.id} value={value.id}>{value.message}</option>
              ))
            }
          </Form.Control>
        </Form.Group>
      </Col>
    </Row>
    </Form>
  );
}
